<template>
<v-data-table
    v-model="selected"
    :headers="headers"
    :items="solicitudes"
     :search="search"
     item-key="IdSolicitud"
    sort-by="fecha"
    show-select
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title style="color:#1C2546;margin-top:40px">Autorizaciones en proceso</v-toolbar-title>
        <v-divider class="mx-4" inset vertical style="margin-top:30px"></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog"  persistent max-width="700"  >  
          <v-card>
            <v-card-title>
              <span class="headline">Detalle de solicitud</span>
            </v-card-title>

            <v-card-text >
              <v-container >
                <v-row  >
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field v-model="editedItem.Deudor" label="Deudor" value="editedItem.Deudor"></v-text-field>
                  </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="editedItem.FechaComprobacion"
                label="Fecha de comprobación"
                append-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="editedItem.FechaComprobacion" @input="menu2 = false"></v-date-picker>
          </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                      <v-select
                      v-model="editedItem.idconcepto"
                      :items="gastos"
                      item-value="id_gasto"
                      item-text="gasto"
                      label="Concepto"
                      data-vv-name="select"
                      required
                      @change="getCuenta()"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="12">
                     <v-select v-model="editedItem.idcuenta" :items="cuentas" item-text="cuenta" item-value="idcuenta" label="Cuenta"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                  <v-select v-model="editedItem.Tipo" :items="tipo" label="Tipo" data-vv-name="select" required></v-select>

                  </v-col>
                    <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.importe" label="Importe"></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="6" md="12">
                    <v-text-field v-model="editedItem.Descripcion" label="Descripción"></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="6" md="12">
                    <v-text-field label="Comprobantes"></v-text-field>
                  </v-col>
                    <v-col cols="12" sm="6" md="12">
                   <v-file-input
                      v-model="files"
                      ref="fileInput"
                      placeholder="Agregar comprobantes"
                      label="Comprobantes"
                      multiple
                      prepend-icon="mdi-paperclip"
                    >
                      <template v-slot:selection="{ text }">
                        <v-chip small label color="primary">{{ text }}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Actualizar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row justify="center">
        <v-dialog v-model="dialogD" persistent max-width="290">
          <v-card>
            <v-card-title class="headline"> Eliminar solicitud </v-card-title>
            <v-card-text>
            ¿ Estás seguro de eliminar esta solicitud ?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogD = false">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="borrar">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-row>
        <v-row justify="center">
              <v-dialog v-model="dialogEnvio" persistent max-width="590">
                <v-card>
                  <v-card-title class="headline"> Enviar solicitudes </v-card-title>
                  <v-card-text>
                  ¿ Estás seguro de enviar las solicitudes a autorización ?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogEnvio = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="EnviarAll">Confirmar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
        </v-row>
         <v-row justify="center">
              <v-dialog v-model="dialogAddGrupo" max-width="590">
                <v-card>
                  <v-card-title class="headline"> Agregar a grupo de comprobantes </v-card-title>
                  <v-card-text>
                  <v-container >
                    <v-row  >
                      <v-col cols="12" sm="6" md="12">
                       <v-select
                        v-model="grupoSelected"
                    :items="grupos"
                    item-text="grupo"
                    item-value="idgrupo"
                    label="Grupos de comprobantes"
                  ></v-select>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogAddGrupo = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="AgregarG">Confirmar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
        </v-row>
      </v-toolbar>
       <v-alert type="success" :value='alert' close-text="Cerrar" dismissible style="margin-top:40px">
              Solicitud editada con exito.
             
        </v-alert>
         <v-alert type="success" :value='alert2' close-text="Cerrar" dismissible style="margin-top:40px">
              Solicitud eliminada con exito.
        </v-alert>
        <v-alert type="success" :value='alert3' close-text="Cerrar" dismissible style="margin-top:40px">
              Se agregaron las solicitudes al grupo de gasto seleccionado.
              
        </v-alert>
        <v-alert type="success" :value='alert4' close-text="Cerrar" dismissible style="margin-top:40px">
              Se enviaron las solicitudes a autorización.
              
        </v-alert>
        
        <v-card-title style="margin-top40px"> 
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
    </template>

     
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import router from '../router/index.js'

export default {
  name: "SolicitudComprobacion",
    data: () => ({
      search: '',
      menu2: false,
      dialog: false,
      dialogD: false,
      dialogAddGrupo: false,
      dialogEnvio: false,
      alert: false,
      alert2: false,
      alert3: false,
      alert4: false,
      alertMsg:'',
      selected: [],
      headers: [
       { text: "Id solicitud", value: "IdSolicitud" },
        {
        text: "Deudor",
        align: "left",
        sortable: true,
        value: "Deudor"
        },
      { text: "Fecha de Comprobacion", value: "FechaComprobacion" },
      { text: "Concepto", value: "Concepto" },
      { text: "ID Concepto", value: "idconcepto" },
      { text: "Importe", value: "importe" },
      { text: "Cuenta", value: "Cuenta" },
       { text: "ID Cuenta", value: "idcuenta" },
      { text: "Tipo", value: "Tipo", sortable: true },
      { text: "Descripcion", value: "Descripcion", sortable: true },
      //{ text: 'Fecha', value: 'fecha' },
      //{ text: "Grupo", value: "IDgrupo", sortable: true },
      { text: "Acciones", value: "actions", sortable: false }
    ],
      desserts: [],
      editedIndex: -1,
     editedItem: {
      IdSolicitud: "",
      Deudor: "",
      idconcepto: "",
      Estado: "",
      Tipo: "",
      Cuenta: "",
      idcuenta:"",
      importe: "",
      Descripcion: "",
      FechaComprobacion: ""
    },
    defaultItem: {
      idconcepto: "",
      Estado: "",
      Tipo: "",
       Cuenta: "",
      importe: "",
      Descripcion: "",
      FechaComprobacion: ""
    },
     gastos: [
          { gasto: "Hotel", id_gasto: "1" },
          { gasto: "Alimentos", id_gasto: "2" },
          { gasto: "Renta de vehículo", id_gasto: "3" },
          { gasto: "Peaje", id_gasto: "4" },
          { gasto: "Gasolina", id_gasto: "5" },
          { gasto: "Avión", id_gasto: "6" },
          { gasto: "Autobús", id_gasto: "7" },
          { gasto: "Taxi", id_gasto: "8" },
          { gasto: "Estacionamiento", id_gasto: "9" },
          { gasto: "Despensa", id_gasto: "10" },
          { gasto: "Agua beber", id_gasto: "11" },
          { gasto: "Papelería", id_gasto: "12" },
          { gasto: "Limpieza", id_gasto: "13" },
          { gasto: "Mensajería", id_gasto: "14" },
          { gasto: "Regalos a clientes", id_gasto: "15" },
          { gasto: "Consumos de alimentos locales", id_gasto: "16" },
          { gasto: "Mtto auto", id_gasto: "17" },
          { gasto: "Gastos de celulares", id_gasto: "18" },
     ],
    
    cuentas: [       
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"1"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"2"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"3"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"4"},
        {cuenta :"613620 ALQUILER TRANSPORTES", idcuenta:"5"},
        {cuenta :"613621 ALQUILER TRANSPORTES ND", idcuenta:"6"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"7"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"8"},
        {cuenta :"606110 GASOLINA", idcuenta:"9"},
        {cuenta :"606111 GASOLINA ND", idcuenta:"10"},
        {cuenta :"625120 REEMBOLSO Y GASTOS VEHICULOS", idcuenta:"11"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"12"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"13"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"14"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"15"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"16"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"17"},
        {cuenta :"613201 GASTOS COMUNES", idcuenta:"18"},
        {cuenta :"613202 GASTOS COMUNES ND", idcuenta:"19"},
        {cuenta :"613201 GASTOS COMUNES", idcuenta:"20"},
        {cuenta :"613202 GASTOS COMUNES ND", idcuenta:"21"},
        {cuenta :"606400 GASTOS DE LIBRERIA", idcuenta:"22"},
        {cuenta :"606300 GASTOS DE LIMPIEZA", idcuenta:"23"},
        {cuenta :"626400 MESSENGER SERVICES", idcuenta:"24"},
        {cuenta :"623400 CUSTOMER GIFTS", idcuenta:"25"},
        {cuenta :"625700 MEALS & ENTERTAINMENT", idcuenta:"26"},
        {cuenta :"615610 MANTENIMIENTO VEHICULO", idcuenta:"27"},
        {cuenta :"615600 MANTENIM DE MAT INFORMATICO", idcuenta:"28"},
    ],
    postBody: "",
    errors: [],
    grupos: [],
    grupoSelected: "",
    idGrupo: null,
    gruposAll: [],
    tipo: ["Comprobacion", "Anticipo"],
    estado: ["Pendiente", "Actualizado", "Cancelado"],
    solicitudes: [],
    arr: [],
    nombres: []
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Actualizar solicitud'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },
     mounted() {
      //Config for axios
      axios.defaults.headers.common['access-token'] = this.$store.state.token;

      axios.interceptors.response.use(function (response){
          if (response.data.message == 'Token inválida') {
              router.push({name: 'login', params: {errorToken: 'true'}});
          }else{
              return response;
          }
      });
      //End config for axios
    this.getSolicitudes();
     this.Dates();
     this.getGasto();
     this.getCuenta();
     this.getGrupos();
  },
    methods: {
     getSolicitudes() {
      axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitud").then(res => {
        this.solicitudes = res.data;
      });
    },
     getGrupos() {
      axios.get("https://"+process.env.VUE_APP_URL+":3000/grupos").then(res => {
        res.data.forEach(element => {
          this.grupos.push(element.nombre);
        });

        res.data.forEach(element => {
         /*var arrGrupos = {
           "Nombre" : element.nombre,
           "ID" : element.id
          }*/
          
        this.gruposAll.push(element.nombre + "|" + element.id);
        });
          
        

      });
    },
      getCuenta() {
      var idg = this.editedItem.idconcepto;
      axios.get("https://"+process.env.VUE_APP_URL+":3000/cuentasgastos/" + idg).then(res => {
       /* var tam = res.data.length;
        var idc = "";
        var desc = "";
        var name = "";
        var arr = [];

        for (var i = 0; i < tam; i++) {
          idc = res.data[i].id_cuenta;
          desc = res.data[i].descripcion;
          name = idc + " " + desc;
          arr.push(name);
        }*/
        this.cuentas = res.data;
      });
    },
  getGasto() {
      axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos").then(res => {
        this.gastos = res.data;
      });
    },
      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        //const index = this.desserts.indexOf(item)
         this.editedIndex = this.desserts.indexOf(item)
         this.editedItem = Object.assign({}, item)
         this.dialogD = true
        //confirm('Estas seguro de eliminas esta solicitud?') && this.desserts.splice(index, 1)
      },
 Dates() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
    },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        let IdSolicitud = this.editedItem.IdSolicitud;
        let idconcepto = this.editedItem.idconcepto;
        let Tipo = this.editedItem.Tipo;
        let Cuenta = this.editedItem.Cuenta;
        let idcuenta= this.editedItem.idcuenta;
        let importe = this.editedItem.importe;
        let Descripcion = this.editedItem.Descripcion;
        let FechaComprobacion = this.editedItem.FechaComprobacion;
      var c = {
        id: IdSolicitud,
        Idconcepto: idconcepto,
        fechaC: FechaComprobacion,
        importe: importe,
        idcuenta: idcuenta,
        cuenta: Cuenta,
        tipo: Tipo,
        descripcion: Descripcion
      };
      axios.put("https://"+process.env.VUE_APP_URL+":3000/solicitud", c).then(function() {
        //this.gastos = res.data;
        this.alert=true;
         this.getSolicitudes();
        this.close()
      });
      },
      borrar () {
       this.dialogD = false
        let IdSolicitud = this.editedItem.IdSolicitud;
      axios.delete("https://"+process.env.VUE_APP_URL+":3000/Deletesolicitud/"+IdSolicitud).then(function() {
         this.alert2=true;
         this.getSolicitudes();
         this.close()
      });
      },
      AgregarG () {
      this.dialogAddGrupo = false
        var r= [];
        for(var i=0;i<this.gruposAll.length;i++){
          var arr = this.gruposAll[i].split("|")
          r.push(arr[0]);
          r.push(arr[1]);
        }
        for(var j=0;j<r.length;j++){
          if(r[j]==this.grupoSelected){
            var idR = r[j+1]; 
          }
        }
        this.idGrupo=idR;  
        //alert('Agrega las solicitudes a grupo de gasto'+this.selected);
        let idsSolicitudes="'";
        let solicitudes=this.selected;
        for(var x=0;x<solicitudes.length;x++){
            if(x<(solicitudes.length)-1)idsSolicitudes+=solicitudes[x].IdSolicitud+'/';
            else idsSolicitudes+=solicitudes[x].IdSolicitud+'|';
        }
        idsSolicitudes=idsSolicitudes.replace("/","','");
        idsSolicitudes=idsSolicitudes.replace("|","'");
        idR=idR.replace('"',"'");
         var c = {
            idGrupo:idR,
            solicitudes: idsSolicitudes,
          };
          axios.put("https://"+process.env.VUE_APP_URL+":3000/addGruposolicitud", c).then(res => {
            this.alertMsg=res.data.message;
            this.alert3=true;
            this.getSolicitudes();

            this.close()
          });
      },
      EnviarAll() {
        this.dialogEnvio = false
        let idsSolicitudes="'";
        let solicitudes=this.selected;
        for(var x=0;x<solicitudes.length;x++){
            if(x<(solicitudes.length)-1)idsSolicitudes+=solicitudes[x].IdSolicitud+'/';
            else idsSolicitudes+=solicitudes[x].IdSolicitud+'|';
        }
        idsSolicitudes=idsSolicitudes.replace("/","','");
        idsSolicitudes=idsSolicitudes.replace("|","'");
         var c = {
            solicitudes: idsSolicitudes,
          };
          axios.put("https://"+process.env.VUE_APP_URL+":3000/enviaAutoriza", c).then(res => {
            this.alertMsg=res.data.message;
            this.alert4=true;
            this.getSolicitudes();
            this.close()
          });
      },
    },
  }
</script>